import { isDevSession } from '../../api/auth'

/**
 * Whether to print the raw error beside the human message.
 *
 * `import.meta.env.DEV` ALONE WOULD BE DEAD CODE HERE. CLAUDE.md's Docker-only
 * rule means `npm run dev` is never run on this project: the local stack is a
 * production Vite build served by nginx, so `DEV` is false on the only machine
 * anyone browses from. Gating on it alone would mean nobody ever sees an error
 * detail anywhere.
 *
 * `isDevSession()` is the app's own Developer Mode marker, set from
 * `api/scripts/dev_login_link.py`'s `&dev=1` and already driving the persistent
 * Dev session badge. It is true exactly when a developer is looking at a local
 * stack, which is the case this switch is for.
 *
 * TRADE-OFF, NAMED. `groundwork_dev_session` is a localStorage key, so a user
 * who sets it by hand on production sees a minified error message and stack.
 * That leaks no data of anyone else's: an error boundary only ever holds the
 * failure from that viewer's own session. The alternative costs the feature
 * its only real user, so this is the deliberate trade.
 */
export function showErrorDetail(): boolean {
  return import.meta.env.DEV || isDevSession()
}
